import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 80px;
  }

  html, body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: 16px;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.textDark};
    background-color: ${({ theme }) => theme.colors.background};
    /* Premium Dot-Matrix Tech Background Pattern */
    background-image: ${({ theme }) =>
      theme.colors.background === '#030303'
        ? `radial-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px)`
        : `radial-gradient(rgba(99, 102, 241, 0.04) 1px, transparent 1px)`};
    background-size: 24px 24px;
    overflow-x: hidden;
    transition: background-color 0.4s ease, color 0.4s ease;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::selection {
    background-color: ${({ theme }) => theme.colors.primary}40;
    color: ${({ theme }) => theme.colors.primary};
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary}50;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primary};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
    transition: ${({ theme }) => theme.transitions.default};
    cursor: pointer;
  }

  button {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    border: none;
    cursor: pointer;
    outline: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif;
    font-weight: ${({ theme }) => theme.typography.heading.fontWeight};
    line-height: 1.2;
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.textDark};
    letter-spacing: -0.02em;
    transition: color 0.4s ease;
  }

  h1 { font-size: ${({ theme }) => theme.typography.heading.h1}; }
  h2 { font-size: ${({ theme }) => theme.typography.heading.h2}; }
  h3 { font-size: ${({ theme }) => theme.typography.heading.h3}; }
  h4 { font-size: ${({ theme }) => theme.typography.heading.h4}; }
  h5 { font-size: ${({ theme }) => theme.typography.heading.h5}; }
  h6 { font-size: ${({ theme }) => theme.typography.heading.h6}; }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.textGray};
    transition: color 0.4s ease;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  section {
    padding: ${({ theme }) => theme.spacing.xl} 0;
    position: relative;
  }

  .container {
    width: 100%;
    max-width: ${({ theme }) => theme.container.maxWidth};
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.container.padding};
  }

  .text-center {
    text-align: center;
  }

  .gradient-text {
    background: ${({ theme }) => theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .glass-card {
    background: ${({ theme }) => theme.colors.glass};
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid ${({ theme }) => theme.colors.glassStroke};
  }

  .glow-border {
    border: 1px solid ${({ theme }) => theme.colors.primary}50;
    box-shadow: 0 0 20px ${({ theme }) => theme.colors.primary}20,
                inset 0 0 20px ${({ theme }) => theme.colors.primary}05;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    html {
      font-size: 14px;
    }

    section {
      padding: ${({ theme }) => theme.spacing.lg} 0;
    }
  }
`;